export default {
  primary: {
    base: '#C0D140',
    lighten: '#ECF1C5',
  },
  secondary: '#DAAD86',
  accent: '#C0D140',
  background: '#1e1d22',
  basic: '#524d48',
}
